import type { LoSiteFeatureItem, LoSiteFeaturesListStyle } from '@/lib/lyrraone-site-blocks';
import { getLoSiteIconComponent } from '@/lib/lyrraone-site-icons';
import { cn } from '@/lib/utils';

interface LoSiteFeatureMarkerProps {
  item: LoSiteFeatureItem;
  index: number;
  listStyle: LoSiteFeaturesListStyle;
  variant?: 'strip' | 'card' | 'inline';
  className?: string;
}

export function LoSiteFeatureMarker({
  item,
  index,
  listStyle,
  variant = 'strip',
  className,
}: LoSiteFeatureMarkerProps) {
  const Icon = getLoSiteIconComponent(item.icon);

  if (Icon) {
    return (
      <span
        className={cn(
          'lo-st-features__marker lo-st-features__marker--icon',
          variant === 'card' && 'lo-st-features__marker--icon-card',
          variant === 'inline' && 'lo-st-features__marker--icon-inline',
          className,
        )}
        aria-hidden
      >
        <Icon className="lo-st-features__marker-icon" />
      </span>
    );
  }

  if (listStyle === 'bullet') {
    return (
      <span
        className={cn(
          'lo-st-features__marker lo-st-features__marker--bullet',
          variant === 'inline' && 'lo-st-features__marker--bullet-inline',
          className,
        )}
        aria-hidden
      />
    );
  }

  return (
    <span
      className={cn(
        'lo-st-features__marker lo-st-features__marker--num',
        variant === 'card' && 'lo-st-features__marker--num-card',
        className,
      )}
      aria-hidden
    >
      {String(index + 1).padStart(2, '0')}
    </span>
  );
}
